import { SupplierIcon } from '../common/components/Icons/SupplierIcon';
import { LogisticIcon } from '../common/components/Icons/LogisticIcon';
import { ManufactureIcon } from '../common/components/Icons/ManufactureIcon';
import { CategoryIcon } from '../common/components/Icons/CategoryIcon';
import { WarehouseAreaIcon } from '../common/components/Icons/WarehouseAreaIcon';
import { ReductionCauseIcon } from '../common/components/Icons/ReductionCauseIcon';
import { TagsIcon } from '../common/components/Icons/TagsIcon';
import { ProductFeatureIcon } from '../common/components/Icons/ProductFeatureIcon';
import { WarehouseIcon } from '../common/components/Icons/WarehouseIcon';
import { DistributionCenterIcon } from '../common/components/Icons/DistributionCenterIcon';

export const SUPPLIER = {
  ICON: SupplierIcon,
  COLOR: '#37aeff',
};

export const LOGISTIC = {
  ICON: LogisticIcon,
  COLOR: '#65be46',
};

export const MANUFACTURER = {
  ICON: ManufactureIcon,
  COLOR: '#fda20a',
};

export const CATEGORIES = {
  ICON: CategoryIcon,
  COLOR: '#ec6c01',
};

export const WAREHOUSE_AREA = {
  ICON: WarehouseAreaIcon,
  COLOR: '#02b389',
};

export const INVENTORY_TAGS = {
  ICON: TagsIcon,
  COLOR: '#0ED3D4',
};

export const INVENTORY_PRODUCT_FEATURE = {
  ICON: ProductFeatureIcon,
  COLOR: '#D40E0E',
};

export const STOCK_REDUCTION_CAUSE = {
  ICON: ReductionCauseIcon,
  COLOR: '#0E2393',
};

export const WAREHOUSE_STYLE = {
  ICON: WarehouseIcon,
  COLOR: '#805FC5',
};

export const DISTRIBUTION_CENTER_STYLE = {
  ICON: DistributionCenterIcon,
  COLOR: '#FDA20A',
};
